import axiosInstance from './config/api';

interface PostPersistTranscriptResponse {
    message: string;
    status: string;
    roomName: string;
}

export const postPersistTranscript = (roomName?: string) => {
    return axiosInstance
        .post<PostPersistTranscriptResponse>(`/calls/${roomName}/transcript/persist`, {})
        .then((res) => res.data);
};
